export default __webpack_public_path__ + "static/media/linkedin.2693e28d.svg";